import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);
root.render(
  <Provider store={store}>
    <App />
    <Tooltip style={{ zIndex: 9999 }} place='bottom' effect='solid' id='tooltip' positionStrategy='fixed' closeOnScroll={true} disableStyleInjection='core' />
  </Provider>
);

// ReactDOM.render(
//     <Provider store={store}>
//       <App />
//     </Provider>
//   ,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
